'use strict';

const allPreOrders = state => state.preOrders;

export default {
  allPreOrders
};
